import { useEffect, useState } from "react";
import { onOpenBracketEditor, type OpenBracketEditor } from "./bracketStore";
import { lazyComponent } from "../components/lazy";

// The host listens from the shell; the modal and the editor load when first opened (audit S-12).
const BracketEditorDialog = lazyComponent(
  () => import("./BracketEditorModal").then((m) => m.BracketEditorDialog),
  "bracket strategies",
);

/**
 * Mounted once per shell: opens the "Bracket strategies" editor as a modal when the DOM/order pad
 * dropdown ("Edit strategies…"), Settings or the command palette asks for it.
 */
export function BracketEditorHost(): React.JSX.Element | null {
  const [open, setOpen] = useState<OpenBracketEditor | null>(null);
  useEffect(
    () =>
      onOpenBracketEditor((d) => {
        setOpen(d);
      }),
    [],
  );
  if (!open) return null;
  return (
    <BracketEditorDialog
      initialId={open.presetId}
      symbol={open.symbol ?? null}
      onClose={() => {
        setOpen(null);
      }}
    />
  );
}
